export const LISTENING_STATE = {
  NOT_STARTED: 'not-started',
  LISTENING: 'listening',
  STOPPED: 'stopped',
} as const;

export type ListeningStateModel = typeof LISTENING_STATE[keyof typeof LISTENING_STATE];

export const ListeningStateEnum = {
  NOT_STARTED: 'not-started',
  LISTENING: 'listening',
  STOPPED: 'stopped',
} as const;

export type ListeningStateEnum = typeof ListeningStateEnum[keyof typeof ListeningStateEnum];

export const GeneratingStateEnum = {
  NOT_STARTED: 'not-started',
  PROCESSING: 'processing',
  FINISHED: 'finished',
  ERROR: 'error',
} as const;

export type GeneratingStateEnum = typeof GeneratingStateEnum[keyof typeof GeneratingStateEnum];
